export const resumeData = {
  "main": {
    "name":"Enrique Marcelo Villa García",
    "occupation":"Software Engineer for Oracle",
    "description":"",
    "image":"profilepic.jpg",
    "bio":`Computer Science and Software Engineering undergrad from Tecnológico de Monterrey, with an 
          interest in web development. I have worked with technologies like React, Express and 
          MongoDB, just to name a few as far as web development goes. Keep on reading to find 
          out what other things I have experience with.`,
    "contactmessage":"",
    "email": "enrique.villa97@hotmail.com",
    "phone": "+52 81 8025 5890",
    "address":{
      "city":"Monterrey",
      "state":"Nuevo León",
    },
    "website": "https://enriquevilla.dev",
    "resumedownload":"https://drive.google.com/file/d/16sYYezP87bKQIz1GbjMabZpmTXqd6h_c/view?usp=sharing",
    "social":[
      {
        "name":"linkedin",
        "url":"https://www.linkedin.com/in/enriquevillag/",
        "className":"fa fa-linkedin"
      },
      // {
      //   "name":"instagram",
      //   "url":"http://instagram.com/enriquevilla_",
      //   "className":"fa fa-instagram"
      // },
      {
        "name":"github",
        "url":"http://github.com/enriquevilla",
        "className":"fa fa-github"
      },
    ]
  },
  "resume":{
    "skillmessage":"Here are some of the technologies that I have worked with previously",
    "education":[
      {
        "school":"Instituto Tecnológico y de Estudios Superiores de Monterrey",
        "degree":"Computer Science and Technology Engineering",
        "graduated":"August 2016 - December 2020",
        "description":`During my time in university I learned a ton of things, but I would say that
                      what stuck most with me is developing quality software and working as a team.
                      During this time I also learned the fundamentals of my main interest right
                      now, which is Web Development, whether it be Frontend or Backend. One of the
                      biggest projects and challenges during these years was my Compilers Design
                      project, where we had to literally design a basic language. It sounds simple
                      enough, but there's a lot going on behind the scenes that we as users can't
                      even begin to understand. It was a lot of hard work, but it will definitely
                      prove to be worth it.`,
      },
      {
        "school":"University of Technology Sydney",
        "degree":"Study abroad semester",
        "graduated":"February 2019 - June 2019",
        "description":`Through my first couple of years of university, 
                      I hadn't considered the idea of studying abroad very much, 
                      but a couple of friends who were going to Australia inspired me to tag along. 
                      I can definitely say it was the best and most fun couple of months in my life. 
                      I think this semester really made me grow and develop myself as a person 
                      and I will never forget this.`
      }
    ],
    "work":[
      {
        "company":"Oracle",
        "title":"Software Engineer",
        "years":"December 2020 - Present",
        "description":`I worked in the Data Visualization software team, where my team focused on
                      everything to do with filters. I developed new features and implemented UI
                      designs for the Date Range Filter on both desktop and mobile. I learned many
                      new things and picked up some useful skills such as writing functional tests 
                      and knowing how to debug front-end code using the browser developer tools.`
      }
    ],
    "skills":[
      {
        "name":"Git",
        "description":`Git is always used for version and change control in every project I work on, 
                      even if it's a solo project. Still can't grasp how something so widely used 
                      was made in a couple of days (shoutout to Linus Torvalds).`,
        "image":"git.jpg",
      },
      {
        "name":"C++",
        "description":`C++ is the first language I learned to code in and it was the language taught to 
                      me in my first few semesters of university in Programming Fundamentals, OOP, and 
                      Data Structures, so even though it brings back dark memories it still has a 
                      place in my heart.`,
        "image":"c++.png",
      },
      {
        "name":"React",
        "description":`I'm fairly new to React but I'm really eager to learn to use this library to its
                      full potential. This website was built with it and even though I don't have a lot
                      of experience with it, I think it's what brought me closer to web development in 
                      general.`,
        "image":"react.jpg",
      },
      {
        "name":"Express",
        "description":`Express is something I learned through my Web Applications Development course at 
                      university, but I really liked working with it and I even used it to develop one 
                      of my projects.`,
        "image":"express.png",
      },
      {
        "name":"Python",
        "description":`I'm surprised by the flexibility of this language. It's very powerful and I would 
                      say without it I would have had a really hard time developing my project for 
                      Compiler Design. Python paired with PLY is what got me through that course.`,
        "image":"python.png",
      },
      {
        "name":"MongoDB",
        "description":`I used Mongo for one of my projects and I really enjoyed working with it. 
                      Projects with larger databases and more complex relations could be harder 
                      to manage with Mongo but my experience with it was nice overall.`,
        "image":"mongo.png"
      },
      {
        "name":"PostgreSQL",
        "description":`I don't have a lot to say about PostgreSQL as I'm fairly new to it but
                      I enjoyed working with it and would definitely use it again for future
                      projects.`,
        "image":"postgresql.png",
      },
      {
        "name":"Java",
        "description":`I used Java for my Videogames Development course at university and it was
                      also the language used to develop our group final projects, so this was my
                      first experience with the language. During this time I also learned more 
                      about using Git to work in a team, rather than just individually.`,
        "image":"java.jpg",
      }
    ]
  },
  "portfolio":{
    "projects": [
      {
        "title":"mYOUsic",
        "description":"Social network based around sharing music",
        "image":"myousic.png",
        "url":"https://myousicapp.herokuapp.com/"
      },
      {
        "title":"Discord bot",
        "description":"A Discord bot that simulates defeating a monster from a game",
        "image":"discordbot.jpg",
        "url":"https://www.github.com/enriquevilla/nightmare-discord-bot"
      }
    ]
  },
  "testimonials":{
    "testimonials":[
      {
        "text":"",
        "user":""
      },
    ]
  }
}



// WEBPACK FOOTER //
// ./src/resumeData.js